// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"46a0051a","753":"dd38ec26"}[chunkId] + ".chunk.js";
};